import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDiamond: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDiamond"><Path fillRule="evenodd" clipRule="evenodd" d="M7.0798 3H16.923L23.8075 10.0046L12.0014 21.8107L0.195312 10.0046L7.0798 3ZM9.56207 7.75L7.31207 10L9.56207 12.25L8.50141 13.3107L5.19075 10L8.50141 6.68934L9.56207 7.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDiamond;
